/* global axios */
import ApiClient from './ApiClient';

class ProjectDeliverables extends ApiClient {
  constructor() {
    super('deliverables', { accountScoped: true });
    this.projectId = null;
  }

  get url() {
    return `${this.baseUrl()}/projects/${this.projectId}/deliverables`;
  }

  get(projectId) {
    this.projectId = projectId;
    return super.get();
  }

  create(projectId, data) {
    this.projectId = projectId;
    return super.create({ deliverable: data });
  }

  update(projectId, id, data) {
    this.projectId = projectId;
    return super.update(id, { deliverable: data });
  }

  delete(projectId, id) {
    this.projectId = projectId;
    return super.delete(id);
  }

  uploadFile(projectId, id, file) {
    this.projectId = projectId;
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/${id}/upload_file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removeFile(projectId, id, fileId) {
    this.projectId = projectId;
    return axios.delete(`${this.url}/${id}/files/${fileId}`);
  }
}

export default new ProjectDeliverables();
